require('./RAServiceCostModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

//commons
const OKModal = require('components/commons/OKModal/OKModal');

class RAServiceCostModal extends React.Component {
    addProfitColumn() {
        return (
            <div>
                <div className="ra-service-cost-model__question">
                    <FormattedText
                        value="raCustomModel-accumulatedProfitQuestion"
                        format="uppercase"
                    />
                </div>
                <div>
                    <FormattedText value="raCustomModel-accumulatedProfitAnswer" />
                </div>
            </div>
        );
    }

    render() {
        const {
            extraColumnForProfit,
            isModalOpen,
            onModalClose,
            titleName,
        } = this.props;
        const addProfitColumn = extraColumnForProfit
            ? this.addProfitColumn()
            : null;
        const modalContent = (
            <div className="ra-service-cost-model__model-text-div">
                <div>
                    <div className="ra-service-cost-model__question">
                        <FormattedText
                            value="raCustomModel-currentValueQuestion"
                            format="uppercase"
                        />
                    </div>
                    <div>
                        <FormattedText value="raCustomModel-currentValueAnswer" />
                    </div>
                </div>
                <div>
                    <div className="ra-service-cost-model__question">
                        <FormattedText
                            value="raCustomModel-calculateProfitQuestion"
                            format="uppercase"
                        />
                    </div>
                    <div>
                        <FormattedText value="raCustomModel-calculateProfitAnswer" />
                    </div>
                </div>
                {addProfitColumn}
                <div>
                    <div className="ra-service-cost-model__question">
                        <FormattedText
                            value="raCustomModel-contributionsInfoTitle"
                            format="uppercase"
                        />
                    </div>
                    <div>
                        <FormattedText value="raCustomModel-contributionsInfoMsg" />
                    </div>
                </div>
                <div>
                    <div className="ra-service-cost-model__question">
                        <FormattedText
                            value="raCustomModel-refundInfoTitle"
                            format="uppercase"
                        />
                    </div>
                    <div>
                        <FormattedText value="raCustomModel-refundInfoMsg" />
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={isModalOpen}
                onCloseCallback={onModalClose}
                onPrimaryButtonClick={onModalClose}
                primaryButtonText="raCustomModel-modelButton"
                shouldCloseOnOverlayClick={false}
                title={titleName}
                titleAlignment="center"
            />
        );
    }
}

RAServiceCostModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    extraColumnForProfit: PropTypes.bool.isRequired,
    titleName: PropTypes.string.isRequired,
};

RAServiceCostModal.defaultTypes = {
    extraColumnForProfit: false,
};

module.exports = RAServiceCostModal;
